<template>
  <div v-if="tabName == $parent.$data.selected" class="pa-2">
    <slot>content</slot>
  </div>
</template>

<script>
export default {
  props: {
    tabName: String,
  },
}
</script>
